/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import React from "react";
import { Redirect, Switch, Route } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import { Layout } from "../_metronic/layout";
import BasePage from "./BasePage";
import { Logout, AuthPage } from "./modules/Auth";
import { StagTest } from "./pages/StagTest";
import ErrorsPage from "./modules/ErrorsExamples/ErrorsPage";
import { ResetPassword } from "./modules/Auth/pages/ResetPassword";
import { CompleteCard } from "./modules/Sale/pages/saleQOrder/add-form-page/complete-card/index";
import PrivacyPage from "./modules/Auth/pages/PrivacyPage";
import PilotLandingPage from "./PilotLandingPage";
import PlaidOAuthReturn from "./modules/Accounting/pages/plaid-oauth/PlaidOAuthReturn";
import BoxViewPage from "./pages/BoxViewPage";

export function Routes() {
  const { isAuthorized, isPilot } = useSelector(
    ({ auth }) => ({
      isAuthorized: auth.user != null,
      isPilot: auth.pilotUrl != null,
    }),
    shallowEqual
  );

  return (
    <Switch>
      {!isAuthorized || isAuthorized ? <Route path="/reset-password" component={ResetPassword} /> : null}
      {!isAuthorized ? <Route path="/status" component={StagTest} /> : null}
      <Route path="/privacy" component={PrivacyPage} />
      <Route path="/sale/invoice/:peculiar_no" component={CompleteCard} />
      <Route path="/pilot" component={PilotLandingPage} />
      <Route path="/plaid-oauth" component={PlaidOAuthReturn} />
      <Route path="/box-view" component={BoxViewPage} />

      {!isAuthorized ? (
        /*Render auth page when user at `/auth` and not authorized.*/
        <Route>
          <AuthPage />
        </Route>
      ) : (
        /*Otherwise redirect to root page (`/`)*/
        <Redirect from="/auth" to="/" />
      )}

      <Route path="/error" component={ErrorsPage} />
      <Route path="/logout" component={Logout} />
      {!isAuthorized ? (
        /*Redirect to `/auth` when user is not authorized*/
        <Redirect to="/auth/login" />
      ) : (
        <Layout>
          <BasePage />
        </Layout>
      )}
    </Switch>
  );
}
